/**
 * American English
 */
const enUS = {
  api: {
    non_field_errors: 'errors',
    tax_id: 'tax id',
    invoice: 'invoice {number}',
    lines: 'lines',
    name: 'name',
    discount_scheme: 'discount type',
    amount: 'amount',
    customer: 'customer',
    document: 'document',
    next_number: 'next number',
    date: 'date',
    due_date: 'due date',
    payments: 'payments',
    file: 'file',
    logo: 'brand'
  },
  cb: {
    expiredSessionMessage: 'The page session has expired',
    pageIsNotExistsMessage: 'The page you are looking for does not exist',
    successAccessMessage: 'We have sent a link to your email to access the portal',
    getAccessAction: 'Request access',
    email: 'Email',
    billingInformation: 'Billing information',
    edit: 'Edit',
    editBillingInformation: 'Edit billing information',
    name: 'Name',
    address: 'Address',
    state: 'State',
    fiscalInformation: 'Tax information',
    businessActivity: 'Business activity',
    contactInformation: 'Contact information',
    billingEmail: 'Billing email',
    phone: 'Phone',
    cancel: 'Cancel',
    save: 'Save',
    subscription: 'Subscription',
    active: 'Active',
    paused: 'Paused',
    cancelled: 'Cancelled',
    startAt: 'Start at',
    endsAt: 'Ends at',
    nextBilling: 'Next billing',
    discount: 'Discount',
    cancelSubscription: 'Cancel subscription',
    chargeToCard: 'Charge to card',
    useMessage: 'This plan is billed based in use recorded in each billing cicle',
    from: 'From',
    by: 'each',
    month: 'month',
    year: 'year',
    useVaries: 'Varies with use',
    qty: 'Qty.',
    addons: 'Add-ons',
    ratesMessage: 'This plugin has a proration of its price in several billing cycles',
    remainingCycles: 'without billing cycles remaining | one billing cycle remaining | {count} billing cycles remaining',
    recurring: 'Recurring',
    oneTime: 'One time',
    rateCalendar: 'In cycle {0}, {1}% will be billed according to {2}',
    cards: 'Cards',
    default: 'Default',
    withoutCardsMessage: 'Without cards registered',
    addCard: 'Add card',
    addCardMessage: 'Then you can register your credit card',
    continue: 'Next',
    confirm: 'Confirm',
    invoices: 'Invoices',
    pending: 'Pending',
    history: 'History',
    withoutInvoicesMessage: 'You dont have invoices yet',
    overdue: 'Overdue',
    due: 'Due',
    paid: 'Paid',
    withCreditNote: 'Has credit note',
    pay: 'Pay',
    poweredByPiriodMessage: 'powered by',
    continueWarningMessage: 'Are you sure to continue?',
    undoneMessage: 'This action cant be undone',
    removeCard: 'Remove card',
    removeCardMessage: 'Performing this action you will not be able to use this card to pay your subscription',
    errorUpdateBillingInformation: 'Error updating your billing information',
    errorUpdateSubscription: 'Error updating your subscription'
  }
}

/**
 * Mexican Spanish
 */
const esMX = {
  api: {
    non_field_errors: 'errores',
    tax_id: 'número fiscal',
    invoice: 'factura {number}',
    lines: 'líneas',
    name: 'nombre',
    discount_scheme: 'tipo de descuento',
    amount: 'monto',
    customer: 'cliente',
    document: 'documento',
    next_number: 'número siguiente',
    date: 'fecha',
    due_date: 'fecha de pago',
    payments: 'pagos',
    file: 'archivo',
    logo: 'logo'
  },
  cb: {
    expiredSessionMessage: 'La sesión de la página ha expirado',
    pageIsNotExistsMessage: 'La página que buscas no existe',
    successAccessMessage: 'Te hemos enviado un enlace a tu correo electrónico para acceder al portal',
    getAccessAction: 'Solicitar acceso',
    email: 'Correo electrónico',
    billingInformation: 'Información de facturación',
    edit: 'Editar',
    editBillingInformation: 'Editar información de facturación',
    name: 'Nombre',
    address: 'Dirección',
    state: 'Estado',
    fiscalInformation: 'Información fiscal',
    businessActivity: 'Actividad comercial',
    contactInformation: 'Información de contacto',
    billingEmail: 'Email de facturación',
    phone: 'Teléfono',
    cancel: 'Cancelar',
    save: 'Guardar',
    subscription: 'Suscripción',
    active: 'Activa',
    paused: 'Pausada',
    cancelled: 'Cancelada',
    startAt: 'Inicio',
    endsAt: 'Término',
    nextBilling: 'Próxima facturación',
    discount: 'Descuento',
    cancelSubscription: 'Cancelar suscripción',
    chargeToCard: 'Cargar a la tarjeta',
    useMessage: 'Este plan se factura de acuerdo al consumo registrado en cada periodo de facturación',
    from: 'desde',
    by: 'por',
    month: 'mes',
    year: 'año',
    useVaries: 'Varía con el uso',
    qty: 'Cant.',
    addons: 'Complementos',
    ratesMessage: 'Este complemento tiene un prorrateo de su precio en varios ciclos de facturación',
    remainingCycles: 'sin ciclos de facturación restantes | un ciclo de facturación restante | {count} ciclos de facturación restantes',
    recurring: 'Recurrente',
    oneTime: 'Una vez',
    rateCalendar: 'En el periodo {0} se facturá el {1}% acorde a {2}',
    cards: 'Métodos de pago',
    default: 'Predeterminada',
    withoutCardsMessage: 'No tienes tarjetas registradas',
    addCard: 'Agregar tarjeta',
    addCardMessage: 'A continuación podrás registrar tu tarjeta de crédito, débito o prepago',
    continue: 'Continuar',
    confirm: 'Confirmar',
    invoices: 'Facturas',
    pending: 'Pendiente',
    history: 'Historial',
    withoutInvoicesMessage: 'Aún no tienes facturas',
    overdue: 'Pendiente de pago',
    due: 'Vencido',
    paid: 'Pagado',
    withCreditNote: 'Tiene nota de crédito',
    pay: 'Pagar',
    poweredByPiriodMessage: 'con la tecnología de',
    continueWarningMessage: '¿Estás seguro de continuar?',
    undoneMessage: 'Esta acción no se puede deshacer',
    removeCard: 'Eliminar tarjeta',
    removeCardMessage: 'Al realizar está acción no podrás usar esta tarjeta para el pago de tu suscripción',
    errorUpdateBillingInformation: 'Error al actualizar tu información de facturación',
    errorUpdateSubscription: 'Error al actualizar tu suscripción'
  }
}

/**
 * Brazilian Portuguese
 */
const poBR = {
  api: {
    non_field_errors: 'erros',
    tax_id: 'CPF',
    invoice: 'fatura {number}',
    lines: 'linhas',
    name: 'nome',
    discount_scheme: 'tipo de desconto',
    amount: 'valor',
    customer: 'cliente',
    document: 'documento',
    next_number: 'próximo número',
    date: 'data',
    due_date: 'data de vencimento',
    payments: 'pagamentos',
    file: 'arquivo',
    logo: 'marca'
  },
  cb: {
    expiredSessionMessage: 'A sessão da página expirou',
    pageIsNotExistsMessage: 'A página que você procura não existe',
    successAccessMessage: 'Enviamos um link para o seu e-mail para acessar o portal',
    getAccessAction: 'Solicitar acesso',
    email: 'E-mail',
    billingInformation: 'Informações de faturamento',
    edit: 'Editar',
    editBillingInformation: 'Editar informações de faturamento',
    name: 'Nome',
    address: 'Endereço',
    state: 'Estado',
    fiscalInformation: 'Informações fiscais',
    businessActivity: 'Atividade comercial',
    contactInformation: 'Informações de contato',
    billingEmail: 'E-mail de faturamento',
    phone: 'Telefone',
    cancel: 'Cancelar',
    save: 'Salvar',
    subscription: 'Assinatura',
    active: 'Ativa',
    paused: 'Pausada',
    cancelled: 'Cancelada',
    startAt: 'Inicia em',
    endsAt: 'Termina em',
    nextBilling: 'Próximo faturamento',
    discount: 'Desconto',
    cancelSubscription: 'Cancelar assinatura',
    chargeToCard: 'Cobrar no cartão',
    useMessage: 'Este plano é faturado com base no uso registrado em cada ciclo de faturamento',
    from: 'De',
    by: 'cada',
    month: 'mês',
    year: 'ano',
    useVaries: 'Varia com o uso',
    qty: 'Quantidade',
    addons: 'Complementos',
    ratesMessage: 'Este plugin tem uma proração de seu preço em vários ciclos de faturamento',
    remainingCycles: 'sem ciclos de faturamento restantes | um ciclo de faturamento restante | {count} ciclos de faturamento restantes',
    recurring: 'Recorrente',
    oneTime: 'Única vez',
    rateCalendar: 'No ciclo {0}, {1}% será faturado de acordo com {2}',
    cards: 'Cartões',
    default: 'Padrão',
    withoutCardsMessage: 'Sem cartões registrados',
    addCard: 'Adicionar cartão',
    addCardMessage: 'Em seguida, você pode registrar seu cartão de crédito',
    continue: 'Próximo',
    confirm: 'Confirmar',
    invoices: 'Faturas',
    pending: 'Pendente',
    history: 'Histórico',
    withoutInvoicesMessage: 'Você ainda não possui faturas',
    overdue: 'Vencida',
    due: 'Vencimento',
    paid: 'Pago',
    withCreditNote: 'Possui nota de crédito',
    pay: 'Pagar',
    poweredByPiriodMessage: 'Desenvolvido por',
    continueWarningMessage: 'Tem certeza de que deseja continuar?',
    undoneMessage: 'Esta ação não pode ser desfeita',
    removeCard: 'Remover cartão',
    removeCardMessage: 'Ao realizar esta ação, você não poderá usar este cartão para pagar sua assinatura',
    errorUpdateBillingInformation: 'Erro ao atualizar suas informações de faturamento',
    errorUpdateSubscription: 'Erro ao atualizar sua assinatura'
  }
}

export default {
  en_US: enUS,
  es_MX: esMX,
  po_BR: poBR
}
